export enum PeriodDate {
    START = "START",
    END = "END"
}

export enum PeriodValue {
    START = "START",
    END = "END",
    REASON = "REASON"
}